const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/LoginPage/styles.ts';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

export const frameStyle = css`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
`;

export const logoFrameStyle = css`
    display: flex;
    align-items: center;
    flex-direction: row;
`;

export const logoFrameStyleVerticalCenter = css`
    margin: auto;
`;

export const logoInlineStyle = css`
    margin-left: ${theme.spacing(3)};
    height: ${theme.spacing(6)};
`;

export const logoStyleSmallDevice = css`
    margin-left: ${theme.spacing(1)};
    height: ${theme.spacing(6)};
`;

export const loginStepsStyleWrapper = css`
    align-items: start;
    display: flex;
    flex-direction: column;
`;

export const loginFormWrapper = css`
    width: 100%;
`;

export const loginStepsStyleWrapperSmDevices = css`
    height: 100%;
    margin: ${theme.spacing(5, 0)};
    display: flex;
    flex-direction: column;

    & :is(p, h1, h2, h3, h4, h5, h6, input, label) {
        text-align: start;
    }
`;

export const errorMsgStyle = css`
    white-space: normal;
`;
